import classNames from "classnames";
import styles from "./index.module.scss";
import MainTitle from "@/components/MainTitle";

const Members = () => {
	return (
		<div className={classNames("container", styles.membersBox)}>
			<MainTitle title="MEMBERS" />
		</div>
	)
}
export default Members;
